import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const Container = styled.iframe`
  width: 100%;
  height: 100%;
`

// Renders the Windy widget as an iframe
// NOTE the widget does not work properly in firefox.  You can not move the map.
const WindyWidget = ({
  latitude,
  longitude,
  width = "550",
  height = "650",
}) => {
  return (
    <Container
      src={`https://embed.windy.com/embed2.html?lat=${latitude}&lon=${longitude}&detailLat=${latitude}&detailLon=${longitude}&width=${width}&height=${height}&zoom=5&level=surface&overlay=wind&product=ecmwf&menu=&message=true&marker=true&calendar=now&pressure=true&type=map&location=coordinates&detail=true&metricWind=km%2Fh&metricTemp=%C2%B0C&radarRange=-1`}
      frameBorder="0"
    ></Container>
  )
}

WindyWidget.propTypes = {
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
}

export default WindyWidget
